// src/app/shared/services/pendo.service.ts
import { Injectable } from '@angular/core';

declare global {
  interface Window {
    pendo?: any;
  }
}

@Injectable({
  providedIn: 'root',
})
export class PendoService {
    private callPendoMethod(methodName: string, ...args: any[]): void {
        if (window.pendo?.[methodName]) {
            window.pendo[methodName](...args);
        } else {
            console.warn(`Pendo is not initialized yet. Method "${methodName}" could not be called.`);
        }
    }

    initialize(visitorData: {
        visitor: { id: string, [key: string]: any },
        account: { id: string, [key: string]: any }
        }): void {
        this.callPendoMethod('initialize', visitorData);
    }

    identify(visitorData: any): void {
        this.callPendoMethod('identify', visitorData);
    }

    track(eventName: string, metadata?: object): void {
        this.callPendoMethod('track', eventName, metadata);
    }

    pageLoad(): void {
        this.callPendoMethod('pageLoad');
    }

    updateOptions(options: object): void {
        this.callPendoMethod('updateOptions', options);
    }
}
